import React, { useContext, useMemo } from 'react';
import { ReportsContainerContext, IReportsContainerContext } from './reportsContainerState/reportsContainerContext';
import Text from 'components/Text/Text';
import ReportsState from './components/ReportsForm/reportsContext/reportsState/ReportsState';
import ReportsForm from './components/ReportsForm/ReportsForm';
import AddNewReportBtn from './components/AddNewReportBtn';
import ModalWindows from './components/ModalWindows';
import classNames from 'classnames';
import style from './ReportsContainer.module.scss';

interface IReportsContainer {
	isVisible: boolean;
}

const ReportsContainer: React.FC<IReportsContainer> = ({ isVisible }) => {
	const { addNewReport, reports } = useContext<IReportsContainerContext>(ReportsContainerContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const reportForms = useMemo(() => {
		return reports.map((report, i) => (
			<ReportsState key={report.id + String(i)}>
				<ReportsForm report={report} />
			</ReportsState>
		));
	}, [reports]);

	return (
		<div className={containerClasses} data-test="ReportsContainer">
			<Text
				translationNameSpace="form"
				translationKey="reportsHeading"
				theme="secondary"
				size="l"
				weight="bold"
			/>
			{reports.length ? reportForms : <div className={style.divider} />}
			<AddNewReportBtn addNewReport={addNewReport} />
			<ModalWindows />
		</div>
	);
};

export default React.memo(ReportsContainer);
